// First-person "viewmodel": the currently selected item shown in the bottom
// right, parented to the camera, with a short swing animation on use. Uses an
// unlit material so it stays visible at night and isn't dimmed by fog.

import * as THREE from 'three';
import { isBlockItem } from '../sim/items';
import { itemSwatch } from './swatch';

const SWING_TIME = 0.28;

export class HeldItem {
  private group = new THREE.Group();
  private mesh: THREE.Mesh | null = null;
  private currentId: number | null | undefined = undefined;
  private swing = 0;

  constructor(private camera: THREE.Camera) {
    this.group.position.set(0.42, -0.38, -0.8);
    camera.add(this.group);
  }

  setItem(id: number | null): void {
    if (id === this.currentId) return;
    this.currentId = id;
    this.clearMesh();
    if (id === null) return;

    const mat = new THREE.MeshBasicMaterial({ color: new THREE.Color(itemSwatch(id)), fog: false });
    let geo: THREE.BufferGeometry;
    if (isBlockItem(id)) {
      geo = new THREE.BoxGeometry(0.28, 0.28, 0.28);
    } else {
      // Tool/weapon: a slim bar held at an angle.
      geo = new THREE.BoxGeometry(0.08, 0.44, 0.08);
    }
    this.mesh = new THREE.Mesh(geo, mat);
    if (!isBlockItem(id)) this.mesh.rotation.z = Math.PI / 5;
    this.group.add(this.mesh);
  }

  triggerSwing(): void {
    this.swing = SWING_TIME;
  }

  update(dt: number): void {
    if (this.swing > 0) this.swing = Math.max(0, this.swing - dt);
    const s = Math.sin((this.swing / SWING_TIME) * Math.PI); // 0 at rest, peaks mid-swing
    this.group.rotation.x = -s * 0.9;
    this.group.position.y = -0.38 - s * 0.12;
  }

  private clearMesh(): void {
    if (!this.mesh) return;
    this.group.remove(this.mesh);
    this.mesh.geometry.dispose();
    (this.mesh.material as THREE.Material).dispose();
    this.mesh = null;
  }

  dispose(): void {
    this.clearMesh();
    this.camera.remove(this.group);
  }
}
